module.exports = __webpack_public_path__ + "708946ebe5352537c41e3cd6cafbad71.svg";